import { useEffect, useRef } from 'preact/hooks'

const useInterval = (callback, delay) => {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }

    if (delay !== null) {
      const interval = setInterval(tick, delay)
      return () => clearInterval(interval)
    }
  }, [delay])
}

export default useInterval
